import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'
import { MediaQueueItem, MediaQueueItemType } from 'shared/src/api/types'
import { addNavigate } from 'shared/src/utils/addNavigate'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import instagramPostIcon from '../../assets/instagram-post-icon.svg'
import instagramStoryIcon from '../../assets/instagram-story-icon.svg'
import Icon from '../Icon'

const useStyles = createUseStyles({
  container: {
    position: 'relative',
  },
  buttonContainer: {
    flexShrink: 0,
    flexGrow: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 136,
    minHeight: 170,
  },
  button: {
    border: 'none',
    background: '#2a2e31',
    position: 'relative',
    height: '100%',
    color: '#fff',
  },
  border: {
    border: '4px solid #E79740',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  otherSelected: {
    opacity: 0.4,
  },
  icon: {
    position: 'absolute',
    left: 8,
    bottom: 12,
  },
  deleteButton: {
    position: 'absolute',
    top: -9,
    right: -9,
    background: 'none',
    border: 'none',
    padding: 0,
    width: 18,
    height: 18,
    borderRadius: 9,
    backdropFilter: 'blur(15px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
})

type State = 'normal' | 'selected' | 'otherSelected'

const MEDIA_TYPE_ICONS: Record<
  Exclude<MediaQueueItemType, null>,
  string | null
> = {
  post: instagramPostIcon,
  story: instagramStoryIcon,
}

interface Props {
  media: MediaQueueItem
  type: MediaQueueItemType
  onClick: () => void
  onDelete?: () => void
  state: State
}

export const Media: FC<Props> = flowMax(
  addDisplayName('MediaItem'),
  addTranslationHelpers,
  addNavigate,
  addProps(({ type }) => ({
    icon: type && MEDIA_TYPE_ICONS[type],
  })),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ media, onClick, onDelete, state, icon, classes, t }) => (
    <div className={classes.buttonContainer}>
      <button
        className={cx(
          classes.button,
          state === 'otherSelected' && classes.otherSelected
        )}
        onClick={onClick}
      >
        {state === 'selected' && <div className={classes.border} />}
        <img
          src={media.thumbnailImage.full}
          alt={media.caption ?? t('admin.resources.media.fields.noCaption')}
        />
        {icon && <img src={icon} className={classes.icon} alt="" />}
        {onDelete && (
          <button onClick={onDelete} className={classes.deleteButton}>
            <Icon name="x" />
          </button>
        )}
      </button>
    </div>
  )
)
